import * as React from 'react'

import { cn } from '@/registry/reapit/lib/utils'

export function ReapitLogo({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="96"
      height="24"
      viewBox="0 0 96 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-6 w-auto', className)}
      {...props}
    >
      <path d="M14.4062 2L19.1877 5.14371V12L23.9991 8.76645V2H14.4062Z" fill="#98C1C2" />
      <path d="M9.5918 12L14.3733 15.1437V22L19.1846 18.7665V12H9.5918Z" fill="#D1263D" />
      <path d="M0 5.2334L4.78148 8.3771V15.2334L9.59285 11.9999V5.2334H0Z" fill="#FD9E1D" />
      <path
        d="M35.3051 5.18536H39.8554C41.8013 5.18536 42.6695 6.5325 42.6695 7.8497C42.6695 9.1669 41.8013 10.514 39.8554 10.514H35.3051V5.18536ZM38.4484 12.6096L42.7892 17.579H45.6332L40.993 12.3402L41.4121 12.2504C44.5255 11.6217 45.0045 9.1669 45.0045 7.78983C45.0045 4.5567 42.3402 3.08981 39.8554 3.05988H33V17.579H35.335V12.5497H38.4185L38.4484 12.6096Z"
        fill="currentColor"
      />
      <path
        d="M48.6268 11.5618L48.7166 11.2325C49.1058 9.8255 50.3032 8.98728 51.9198 8.98728C53.6561 8.98728 54.7338 9.8255 54.9134 11.2625L54.9434 11.5618H48.6268ZM55.7517 8.65798C54.8835 7.70002 53.5364 7.1911 51.8599 7.1911C48.6567 7.1911 46.5013 9.31658 46.5013 12.4599C46.5013 15.7828 48.6268 17.8485 52.0695 17.8485C53.6861 17.8485 55.2727 17.2797 56.2606 16.3816L54.9434 15.0943C54.195 15.693 52.9676 15.9924 52.1294 15.9924C50.2434 15.9924 48.9262 15.0344 48.7166 13.5077L48.6867 13.2083H57.009C57.0988 11.2624 56.6797 9.67582 55.7517 8.65798Z"
        fill="currentColor"
      />
      <path d="M86.1371 7.46053H84.0416V17.579H86.1371V7.46053Z" fill="currentColor" />
      <path
        d="M91.1365 16.8606C91.7353 17.4294 92.6333 17.7287 93.6811 17.6988C94.3697 17.6688 94.9085 17.579 95.5372 17.3395L94.9684 15.6032C94.6091 15.7529 94.19 15.8427 93.8607 15.8427C92.8429 15.8427 92.2442 15.1841 92.2442 14.0765V9.25671H95.1779V7.5204H92.2741V4.5567L90.1786 4.76625V7.5204H88.2028V9.25671H90.1786V14.0765C90.1786 15.3039 90.5079 16.2319 91.1365 16.8606Z"
        fill="currentColor"
      />
      <path
        d="M63.7746 15.8727C61.9485 15.8727 60.4816 14.3758 60.4816 12.5797C60.4816 10.7835 61.9785 9.28665 63.7746 9.28665C65.5708 9.28665 67.0676 10.7835 67.0676 12.5797C67.0676 14.3758 65.6008 15.8727 63.7746 15.8727ZM69.1931 17.5491V7.49046H67.1575V8.38855L66.918 8.20894C65.9899 7.55033 64.9122 7.1911 63.7746 7.1911C60.8109 7.1911 58.416 9.58601 58.416 12.5497C58.416 15.5134 60.8109 17.9083 63.7746 17.9083C64.9122 17.9083 65.9899 17.5491 66.918 16.8905L67.1575 16.7109V17.5491H69.1931Z"
        fill="currentColor"
      />
      <path
        d="M76.8269 9.19683C78.653 9.19683 80.1199 10.6937 80.1199 12.4898C80.1199 14.286 78.6231 15.7828 76.8269 15.7828C75.0307 15.7828 73.5339 14.286 73.5339 12.4898C73.5339 10.6937 75.0008 9.19683 76.8269 9.19683ZM76.8269 17.8485C79.7906 17.8485 82.1855 15.4535 82.1855 12.4898C82.1855 9.52613 79.7906 7.13122 76.8269 7.13122C75.6893 7.13122 74.6116 7.49046 73.6836 8.14906L73.4441 8.32868V7.49046H71.4084V21.83H73.4441V16.651L73.6836 16.8306C74.6116 17.4892 75.6893 17.8485 76.8269 17.8485Z"
        fill="currentColor"
      />
      <path
        d="M85.0894 3C84.4607 3 83.8021 3.38917 83.8021 4.28727C83.8021 5.18536 84.4607 5.57453 85.0894 5.57453C85.718 5.57453 86.3766 5.18536 86.3766 4.28727C86.3766 3.38917 85.718 3 85.0894 3Z"
        fill="currentColor"
      />
    </svg>
  )
}
